export const FLOW_SET_CURRENT_CUSTOMER = 'flow/current_customer/set';
export const FLOW_SET_CURRENT_CUSTOMER_VERIFIED = 'flow/current_customer/set_verified';
export const FLOW_SET_CURRENT_STEP = 'flow/current_step/set';
export const FLOW_ADD_CUSTOMER = 'flow/customers/add';
export const FLOW_SET_FORM_DATA = 'flow/form_data/set';
export const FLOW_CLEAR_FORM_DATA = 'flow/form_data/clear';
